import { createSlice } from '@reduxjs/toolkit';
import {
  uploadOthersFile
} from './importPersonsThunk';

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const uploadOthersSlice = createSlice({
  name: 'uploadOthers',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadOthersFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadOthersFile.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(uploadOthersFile.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});


export default uploadOthersSlice.reducer;